import React from "react";
import { Button } from "@material-ui/core";
import {
	listenAuthStateChange,
	AuthCallBackParams,
	signOut,
	signInWithGoogle,
} from "../firebase";
import {
	firebaseConfig,
	getIdToken,
	signInWithPhoneNumber,
	enterOTP,
	signInAnonymously,
	// signInWithFaceBook,
	setDoc,
	getDoc,
	COLLECTIONS,
} from "../firebase";

export const AuthTest: React.FC = (props: any) => {
	const loginWithPhoneNumber = async () => {
		const number: any = prompt("Please enter mobile number");
		const result: any = await signInWithPhoneNumber("+971" + number);
		if (result.verificationId) {
			const otp: any = prompt(`Please enter otp sent to ${number}`);
			await enterOTP(result, otp);
		}
		alert("Please check console");
	};

	const verifyIdToken = () => {
		const token: any = prompt("Please Paste your token");
		if (token) {
			const data = JSON.parse(atob(token.split(".")[1]));
			if (!data.exp) {
				alert("Not a valid jwt");
				return;
			}
			if (data.exp * 1000 < new Date().getTime()) {
				alert("Token Expired");
				//   const t = getIdToken(true);
			}
		}
	};

	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				justifyContent: "space-between",
				alignItems: "center",
			}}
		>
			<Button
				onClick={() => loginWithPhoneNumber()}
				style={{
					width: "20%",
					backgroundColor: "#43c5a6",
					color: "white",
					marginTop: 30,
				}}
			>
				Login With Phone
			</Button>
			<Button
				style={{
					width: "20%",
					backgroundColor: "#d44336",
					color: "white",
					marginTop: 30,
				}}
				onClick={() => signInWithGoogle()}
			>
				Login with Gmail
			</Button>
			{/* <Button
				style={{
					width: "20%",
					backgroundColor: "#3b5998",
					color: "white",
					marginTop: 30,
				}}
				onClick={() => signInWithFaceBook()}
			>
				Login with Facebook
			</Button> */}
			<Button
				style={{
					width: "20%",
					backgroundColor: "black",
					color: "white",
					marginTop: 30,
				}}
			>
				Login With Apple
			</Button>
			<Button
				onClick={() => signInAnonymously()}
				style={{
					width: "20%",
					backgroundColor: "pink",
					color: "white",
					marginTop: 30,
				}}
			>
				Login Anonymously
			</Button>
			<Button
				style={{
					width: "20%",
					backgroundColor: "#0876b7",
					color: "white",
					marginTop: 30,
				}}
				onClick={() => getIdToken()}
			>
				Generate Id Token
			</Button>
			<Button
				onClick={() => verifyIdToken()}
				style={{
					width: "20%",
					backgroundColor: "#0876b7",
					color: "white",
					marginTop: 30,
				}}
			>
				Verify Id Token
			</Button>
			<Button
				style={{
					width: "20%",
					backgroundColor: "#0876b7",
					color: "white",
					marginTop: 30,
				}}
				onClick={() => getIdToken(true)}
			>
				Generate Refresh Token
			</Button>
			<Button
				onClick={() => signOut()}
				style={{
					width: "20%",
					backgroundColor: "purple",
					color: "white",
					marginTop: 30,
				}}
			>
				Sign Out
			</Button>
		</div>
	);
};
